import apiClient from './client';
import type { ApiErrorResponse } from './auth';

export interface UserSettings {
  user_id: number;
  defaultLanguage: 'ro' | 'en';
}

export interface UpdateUserSettingsRequest {
  defaultLanguage?: 'ro' | 'en';
}

/**
 * Get user settings
 */
export async function getUserSettings(): Promise<UserSettings> {
  const response = await apiClient.get<UserSettings | ApiErrorResponse>('/user/settings');
  const data = response.data;
  
  if ('error' in data) {
    throw new Error(data.error?.message || 'Failed to get user settings');
  }
  
  return data as UserSettings;
}

/**
 * Update user settings
 */
export async function updateUserSettings(payload: UpdateUserSettingsRequest): Promise<UserSettings> {
  const response = await apiClient.put<UserSettings | ApiErrorResponse>('/user/settings', payload);
  const data = response.data;
  
  if ('error' in data) {
    throw new Error(data.error?.message || 'Failed to update user settings');
  }
  
  return data as UserSettings;
}





